import { Component, computed, input } from '@angular/core';

export interface StatusPieChartSegment {
  label: string;
  value: number;
  color: string;
}

interface PieSlice {
  readonly color: string;
  readonly dashArray: string;
  readonly dashOffset: number;
}

/**
 * Mesma técnica de `perfil-cadastro.component` (SVG <circle> por fatia com
 * stroke-dasharray, normalizado por pathLength=100).
 */
const PIE_PATH_LENGTH = 100;
const PIE_START_OFFSET = 25;

@Component({
  selector: 'app-status-pie-chart',
  imports: [],
  templateUrl: './status-pie-chart.component.html',
  styleUrl: './status-pie-chart.component.scss',
})
export class StatusPieChartComponent {
  readonly segments = input.required<readonly StatusPieChartSegment[]>();
  readonly pathLength = PIE_PATH_LENGTH;

  readonly total = computed(() => this.segments().reduce((sum, s) => sum + s.value, 0));

  readonly pieSlices = computed<PieSlice[]>(() => {
    const total = this.total();
    if (total <= 0) {
      return [];
    }

    let acumulado = 0;
    return this.segments().map((s) => {
      const percentual = (s.value / total) * PIE_PATH_LENGTH;
      const slice: PieSlice = {
        color: s.color,
        dashArray: `${percentual} ${PIE_PATH_LENGTH - percentual}`,
        dashOffset: PIE_START_OFFSET - acumulado,
      };
      acumulado += percentual;
      return slice;
    });
  });

  percentOf(value: number): string {
    const total = this.total();
    if (total === 0) {
      return '0%';
    }

    return `${Math.round((value / total) * 100)}%`;
  }
}
